import styled from 'styled-components';
import { styledWithProps } from '../../utils';

export default styledWithProps()(styled.button)`
display: inline-block;
  width: 64px;
  height: 64px;
  margin-top: -2px;
  opacity: 0.7;
  border-radius: 6px;
  mask-repeat: no-repeat;
  mask-position: center center;
  mask-image: url(/media/icons/add-frame.svg);
  vertical-align: top;
  background-color: rgba(var(--controller-fg-rgb), 1);
`;



// WEBPACK FOOTER //
// ./src/controller/components/AddFrameButton.ts